import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Pages::Catalog::Action::Apply @action={{@model}} />",{ moduleName: "frontend/catalog/action/apply/index/template.hbs" })